import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, DrawerBody, DrawerFooter, DrawerHeader, Heading, Stack, Text } from '@chakra-ui/react'

import { RoleFilter } from 'Attendances/types'
import RoleFilterForm from 'Attendances/components/RoleFilterForm'
import { useCustomFormRoleSelectionDrawerManager } from '../../contexts/CustomFormRoleSelectionDrawerManager/Provider'
import CustomFormFilterWarningAlert from '../../../../components/CustomFormFilterWarningAlert'

type Props = {
  onClose: () => void
}

const SearchRoleOnCustomForm: FC<Props> = ({ onClose }) => {
  const { handleSubmit, register } = useForm<RoleFilter>({ defaultValues: { name: '' } })

  const { setView, filter, setFilter, setLoadingRoles } = useCustomFormRoleSelectionDrawerManager()

  function onSubmit(roleFilter: RoleFilter) {
    setFilter({ ...filter, ...roleFilter })
    setLoadingRoles(true)
    setView('SELECT_ROLE')
  }

  return (
    <>
      <DrawerHeader>
        <Text>Selecionar um papel</Text>
        <Heading color="primary">Pesquisar os papéis</Heading>
      </DrawerHeader>

      <DrawerBody>
        <Stack spacing={4}>
          <CustomFormFilterWarningAlert />

          <RoleFilterForm register={register} />
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>

        <Button onClick={() => handleSubmit(onSubmit)()}>Buscar papel</Button>
      </DrawerFooter>
    </>
  )
}

export default SearchRoleOnCustomForm
